<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row v-if="localDadosModal">
                    <b-col cols="4">
                        <div><label>Numero: {{ localDadosModal.id }}</label></div>
                        <div><label>Tombamento: {{ localDadosModal.numTombamento }}</label></div>
                        <div><label>Abertura: {{ formatDate(localDadosModal.dhCriacao) }}</label></div>
                    </b-col>
                    <b-col cols="4">
                        <lg-form-input v-if="localDadosModal.descricaoResumida"
                            v-model="localDadosModal.descricaoResumida" label="Descrição:" description=" " cols="12"
                            sm="12" md="12" disabled />
                        <b-form-group label="Problema Relatado:" label-for="textAreaExample3"
                            class="b-form-group-styled">
                            <b-form-textarea v-model="localDadosModal.problemaRelatado" id="textAreaExample3" rows="2"
                                disabled></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4" class="text-right">
                        <b-button id="loadSMIBP" size="sm" style="height: 30px" pill variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="loadSMIBP" title="Localizar"></b-tooltip>
                        </b-button>
                        <b-button v-if="mostrarAdicionar" id="novo" @click=" showModalTipoDeManutencaoCadastro()"
                            size="sm" pill variant="secondary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                        </b-button>

                    </b-col>
                </b-form-row>
            </b-card>
            <b-card bg-variant="light">
                <b-table head-variant="dark" responsive class="mt-2" small :busy="this.busy" :items="records"
                    :fields="tableFields" :hover="true" show-empty>
                    <template #empty>
                        <p class="text-center">Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(situacao)="{ item }">
                        <b-form-checkbox v-model="item.situacao" name="check-button" switch size="lg" :value="1"
                            :unchecked-value="0" disabled />
                    </template>
                </b-table>

                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>

            </b-card>
        </b-card-body>
        <TipoDeManutencaoCadastro v-if="showModal" id="modalTipoDeManutencaoCadastroId" :prefix="prefix + title + ' > '"
            :solicitacaoManutencaoId='idSolicitacao' @close='closeModal' />
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import { default as TipoDeManutencaoCadastro } from "@/modules/patrimonio/solicitacao-manutencao/TipoDeManutencaoCadastro.vue"
import moment from 'moment'


export default {
    name: "TipoDeManutencaoList",
    components: {
        LgFormInput,
        TipoDeManutencaoCadastro
    },
    props: {
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Manutenção de Item Bem Permanente"
        },

        mostrarAdicionar: {
            type: Boolean,
            default: false
        },
        idSolicitacao: Number,
    },
    data() {
        return {
            showModal: false,
            localDadosModal: null,
            busy: false,
            perpage: 10,
            perPageOptions: [10, 25, 50, 100],
        }
    },
    mixins: [ListResourceMixin],
    async beforeMount() {

        var { data } = await new ResourceService(`/api/solicitacaomanutencao`).get(this.idSolicitacao);

        this.localDadosModal = data;

        this.$service = new ResourceService(`/api/manutencaoitembempermanente`);
        this.load()
    },
    watch: {
        page() {
            this.load()
        },
    },
    computed: {
        manutencaoItens() {
            return this.localDadosModal ? this.localDadosModal.manutencaoItens : []
        },
        tableFields() {
            return [
                { key: "dhCriacao", label: "Data", formatter: (value) => this.formatDate(value) },
                { key: "tipoManutencao.descricao", label: "Descrição" },
                { key: "pessoa.nome", label: "Responsável" },
                { key: "observacao", label: "Observações" },
            ]
        },
    },
    methods: {
        showModalTipoDeManutencaoCadastro() {
            this.$bvModal.show("modalTipoDeManutencaoCadastroId")
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.$bvModal.hide("modalTipoDeManutencaoCadastroId")
            this.load()
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY HH:mm')
        },
        async load() {
            this.busy = true

            this.busy = true
            this.filtro = {};
            this.filtro.id = this.idSolicitacao;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            })
        },
    },
}
</script>

<style scoped>
.b-form-group-styled {
    font-size: 12px;
    margin-bottom: 1rem;
    padding: 0;
}

.b-form-input-styled {
    max-height: 21px;
    margin-top: -8px;
}

.b-form-group-styled label {
    font-size: 12px !important;
    margin-bottom: 5px !important;
}
</style>